import createAxiosInstance from "../../utils/axiosInstance";

export const getApprenticeshipList = async (host, accessToken, endPoint) => {
    const url = `${host}api/v1/`;
    try {
      const axiosInstance = createAxiosInstance(accessToken, url);
      const response      = await axiosInstance.get(endPoint);
      return response.data.data;
    } catch(err) {
      console.log(err);
    }
}